import { logNotification, LogLevel, Category } from './OTelNotifications';
var TokenType;
(function (TokenType) {
    TokenType[TokenType["Aria"] = 0] = "Aria";
    TokenType[TokenType["Nexus"] = 1] = "Nexus";
})(TokenType || (TokenType = {}));
export var TenantTokenManager;
(function (TenantTokenManager) {
    var ariaTokenMap = {};
    var nexusTokenMap = {};
    // tslint:disable-next-line:no-any
    var tenantTokens = {};
    function setTenantToken(namespace, ariaTenantToken, nexusTenantToken) {
        var parts = namespace.split('.');
        // Ensure that the provided namespace is valid
        if (parts.length < 2 || parts[0] !== 'Office') {
            logNotification(LogLevel.Error, Category.Core, function () {
                return "Invalid namespace: " + namespace;
            });
            return;
        }
        // Create the leaf node first
        var leaf = Object.create(Object.prototype);
        if (ariaTenantToken) {
            leaf['ariaTenantToken'] = ariaTenantToken;
        }
        if (nexusTenantToken) {
            leaf['nexusTenantToken'] = nexusTenantToken;
        }
        // Then walk backwards adding the path to the root
        var node = leaf;
        var index;
        for (index = parts.length - 1; index >= 0; --index) {
            var parentNode = Object.create(Object.prototype);
            parentNode[parts[index]] = node;
            node = parentNode;
        }
        setTenantTokens(node);
    }
    TenantTokenManager.setTenantToken = setTenantToken;
    function setTenantTokens(tokenTree) {
        if (typeof tokenTree !== 'object') {
            throw new Error('tokenTree must be an object');
        }
        tenantTokens = mergeTenantTokens(tenantTokens, tokenTree);
    }
    TenantTokenManager.setTenantTokens = setTenantTokens;
    function getTenantTokens(eventName) {
        var ariaTenantToken = getAriaTenantToken(eventName);
        var nexusTenantToken = getNexusTenantToken(eventName);
        if (!nexusTenantToken || !ariaTenantToken) {
            throw new Error('Could not find tenant token for ' + eventName);
        }
        return {
            ariaTenantToken: ariaTenantToken,
            nexusTenantToken: nexusTenantToken
        };
    }
    TenantTokenManager.getTenantTokens = getTenantTokens;
    function getAriaTenantToken(eventName) {
        // Return cached token if it exists for eventName
        if (ariaTokenMap[eventName]) {
            return ariaTokenMap[eventName];
        }
        var ariaToken = getTenantToken(eventName, TokenType.Aria);
        if (typeof ariaToken === 'string') {
            ariaTokenMap[eventName] = ariaToken;
            return ariaToken;
        }
        return undefined;
    }
    TenantTokenManager.getAriaTenantToken = getAriaTenantToken;
    function getNexusTenantToken(eventName) {
        // Return cached token if it exists for eventName
        if (nexusTokenMap[eventName]) {
            return nexusTokenMap[eventName];
        }
        var nexusToken = getTenantToken(eventName, TokenType.Nexus);
        if (typeof nexusToken === 'number') {
            nexusTokenMap[eventName] = nexusToken;
            return nexusToken;
        }
        return undefined;
    }
    TenantTokenManager.getNexusTenantToken = getNexusTenantToken;
    function getTenantToken(eventName, tokenType) {
        // Find token
        var pieces = eventName.split('.');
        var node = tenantTokens;
        var token = undefined;
        if (!node) {
            return undefined;
        }
        for (var i = 0; i < pieces.length - 1; i++) {
            if (node[pieces[i]]) {
                node = node[pieces[i]];
                if (tokenType === TokenType.Aria && typeof node.ariaTenantToken === 'string') {
                    // set token if one is available
                    token = node.ariaTenantToken;
                }
                else if (tokenType === TokenType.Nexus && typeof node.nexusTenantToken === 'number') {
                    token = node.nexusTenantToken;
                }
            }
        }
        return token;
    }
    // tslint:disable-next-line:no-any
    function mergeTenantTokens(existingTokenTree, newTokenTree) {
        if (typeof newTokenTree !== 'object') {
            return newTokenTree;
        }
        for (var _i = 0, _a = Object.keys(newTokenTree); _i < _a.length; _i++) {
            var key = _a[_i];
            if (key in existingTokenTree && typeof (existingTokenTree[key] === 'object')) {
                existingTokenTree[key] = mergeTenantTokens(existingTokenTree[key], newTokenTree[key]);
            }
            else {
                existingTokenTree[key] = newTokenTree[key];
            }
        }
        return existingTokenTree;
    }
    function clear() {
        ariaTokenMap = {};
        nexusTokenMap = {};
        tenantTokens = {};
    }
    TenantTokenManager.clear = clear;
})(TenantTokenManager || (TenantTokenManager = {}));
//# sourceMappingURL=TenantTokenManager.js.map